<div class="flex justify-center h-full">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Resend Code</h2>
    <div class="text-gray-tricon">Please fill in the fields below to resend your code.</div>
    <form id="forgotPasswordForm" #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Email Address</mat-label>
        <input matInput type="text" name="Email" id="Email" required email [(ngModel)]="email" #EmailAddr="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <button mat-flat-button color="primary" type="submit" class="my-2" [disabled]="!forgotPasswordForm.form.valid">RESEND CODE</button>

    </form>
  </div>
</div>
